import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Sparkles, Loader2, CornerDownLeft, X } from "lucide-react";

const EXAMPLES = [
  "Sposta targa AB123CD in manutenzione fino a domani",
  "Quante auto disponibili questo weekend?",
  "Metti la tariffa della EF456GH a 120 euro",
  "Blacklist Mario Rossi per mancato pagamento",
];

export const NlpCommandBar = () => {
  const nav = useNavigate();
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const run = async (e) => {
    e.preventDefault();
    if (!text.trim() || loading) return;
    setLoading(true);
    setResult(null);
    try {
      const r = await api.post("/nlp/command", { text: text.trim() });
      setResult(r.data);
      if (r.data.navigate) {
        toast.success(r.data.message);
        setTimeout(() => nav(r.data.navigate), 600);
      } else {
        toast.success("Comando eseguito");
      }
      setText("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Errore esecuzione comando";
      setResult({ intent: "error", message: `⚠️ ${msg}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-5" data-testid="nlp-command-bar">
      <form onSubmit={run} className="relative">
        <Sparkles size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#ff0033]" />
        <input
          data-testid="nlp-command-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={`Comando rapido AI — es. "${EXAMPLES[Math.floor(Date.now() / 60000) % EXAMPLES.length]}"`}
          className="w-full glass-strong border border-white/10 rounded-xl pl-11 pr-12 py-3 text-sm text-white placeholder:text-white/30 focus:border-[#ff0033]/50 outline-none transition-colors"
        />
        <button
          type="submit"
          data-testid="nlp-command-submit"
          disabled={loading || !text.trim()}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-[#ff0033] disabled:opacity-30 transition-colors"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <CornerDownLeft size={16} />}
        </button>
      </form>
      <AnimatePresence>
        {result && (
          <motion.div
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            className="glass rounded-xl border border-white/10 mt-2 px-4 py-3 flex items-start justify-between gap-3"
            data-testid="nlp-command-result"
          >
            <div className="text-sm text-white/85 leading-relaxed">
              {result.message}
              {result.details?.disponibili?.length > 0 && (
                <div className="text-[11px] text-white/45 mt-1.5">
                  {result.details.disponibili.slice(0, 8).join(" · ")}
                  {result.details.disponibili.length > 8 && ` +${result.details.disponibili.length - 8} altri`}
                </div>
              )}
            </div>
            <button data-testid="nlp-result-close" onClick={() => setResult(null)} className="text-white/30 hover:text-white shrink-0 mt-0.5">
              <X size={14} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
